var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: { "hide-footer": "", size: "xl", title: "Verknüpfte Dateien" },
      on: {
        hide: function ($event) {
          return _vm.reset()
        },
      },
      model: {
        value: _vm.isModalOpen,
        callback: function ($$v) {
          _vm.isModalOpen = $$v
        },
        expression: "isModalOpen",
      },
    },
    [
      _c(
        "div",
        { staticClass: "record-note-files-modal loading-content-container" },
        [
          _vm.noteFilesLoading > 0
            ? _c(
                "div",
                {
                  staticClass:
                    "loading-overlay d-flex justify-content-center pt-5",
                },
                [_c("csp-loading-indicator")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("csp-record-detail-document-upload", {
            attrs: {
              "damage-record-note-id": _vm.noteId,
              "record-id": _vm.recordId,
            },
            on: { "upload-success": _vm.onUploadSuccess },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "clear-float mb-3" }),
          _vm._v(" "),
          _vm.noteFilesLoading === 0 && _vm.recordFilesForTable.length === 0
            ? _c("b-alert", { attrs: { show: "", variant: "info" } }, [
                _vm._v("\n            Keine Dokumente vorhanden\n        "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.noteFilesLoading === 0 && _vm.recordFilesForTable.length > 0
            ? _c("b-table", {
                attrs: {
                  fields: _vm.fileTableFields,
                  items: _vm.recordFilesForTable,
                  responsive: true,
                  striped: "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "table-colgroup",
                      fn: function (scope) {
                        return _vm._l(scope.fields, function (field) {
                          return _c("col", {
                            key: field.key,
                            style: { width: field.width ?? "auto" },
                          })
                        })
                      },
                    },
                    {
                      key: "cell(dateSet)",
                      fn: function (data) {
                        return [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.formatDateTime(data.value)) +
                              "\n            "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(hideForGroup)",
                      fn: function (data) {
                        return [
                          _c("csp-hide-for-group", {
                            attrs: {
                              "default-value": data.value,
                              options: _vm.hideForGroupOptions,
                              "record-id": _vm.recordId,
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "cell(actions)",
                      fn: function (data) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "table-actions",
                              staticStyle: { "text-align": "right" },
                            },
                            [
                              _vm.canPreviewDocuments
                                ? _c(
                                    "a",
                                    {
                                      attrs: { href: "#", title: "Vorschau" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.showFile(data.item.fileId)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "inticon-autoclaim_detail",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.getDownloadFileUrl(
                                      data.item.fileId
                                    ),
                                    title: "Datei herunterladen",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "inticon-autoclaim_einzeldownload",
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1164786906
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }